<template>
    <div class='video-player'>
        <span v-if='flashFlag'>
                <embed :src='url' :allowFullScreen='allowFullScreen' :quality='quality' :width='width' :height='height' align='middle' allowScriptAccess='always' type='application/x-shockwave-flash'></embed>
        </span>
        <span v-else>
            <video class='video-js vjs-default-skin vjs-big-play-centered' controls preload='auto' :width='width' :height='height' :poster='poster'>
                <source :src='url'>
                <p class='vjs-no-js'>
                    要观看此视频，请启用浏览器的Javascript脚本功能，并升级到<a href='http://videojs.com/html5-video-support/' target='_blank'>支持Html5视频</a>的浏览器 </p>
            </video>
        </span>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    export default {
        name: 'swb-video-player',
        desc: '视频播放器',
        props: {
            flashFlag: {//是否flash
                type : Boolean,
                default: false
            },
            url: {//视频url
                type: String,
                default: null
            },
            width: {
                type: Number,
                default: 480
            },
            height: {
                type: Number,
                default: 300
            },
            poster: {//海报图片
                type: String,
                default: null
            },
            quality: {
                type: String,
                default: 'high'
            },
            allowFullScreen: {//是否允许全屏
                type: Boolean,
                default: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/ctrl/VideoPlayer.vue